import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=4e2c7061&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"
import style0 from "./Master.vue?vue&type=style&index=0&id=4e2c7061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c7061",
  null
  
)

export default component.exports